export default __webpack_public_path__ + "8914de47fe20c10df73fe997cece6216.jpeg";